import React from 'react';
import styled from '@emotion/styled';

import useToggle from '@shared/v2/hooks/useToggle';

import Button from '@/components/Button';
import useAlternativeOffer from '@/v2/components/pages/PackageViewV2/hooks/useAlternativeOffer';
import AlternativeOptionModal from './components/AlternativeOptionModal';

const OtherOptionButton = styled(Button)`
  flex: 1 1 0;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
`;

const AlternativeOfferCta = () => {
  const { value: isOpen, setOn, setOff } = useToggle();

  const {
    alternativeOffer,
    alternativeOfferPackageOption,
    handleSelectAltOffer,
  } = useAlternativeOffer() || {};
  const { offer, roomType, leadInOffer } = alternativeOffer || {};

  if (!offer || !roomType) {
    return null;
  }

  return (
    <>
      <OtherOptionButton outline onClick={setOn} width="100%" mt="0">
        Other option
      </OtherOptionButton>
      <AlternativeOptionModal
        roomType={roomType}
        offer={{ ...offer, leadInOffer }}
        packageName={alternativeOfferPackageOption?.title}
        isOpen={isOpen}
        onClose={setOff}
        onSubmit={async () => {
          await handleSelectAltOffer();
          setOff();
        }}
        onCancel={setOff}
      />
    </>
  );
};

export default AlternativeOfferCta;
